<template>
</template>

<script>
import gql from 'graphql-tag';

export default {
  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onNotification: {
        query: gql`
          subscription {
            onNotification {
              message
              type
              resourceType
            }
          }
        `,
        result(data) {
          const notification = data.data.onNotification;
          this.$notify({
            title: this.title(notification.resourceType),
            message: notification.message,
            type: notification.type.toLowerCase(),
          });
        },
      },
    },
  },
  methods: {
    title(str) {
      return str.replace('_', ' ').replace(/(^|\s)\S/g, t => t.toUpperCase());
    },
  },
};
</script>



// WEBPACK FOOTER //
// Notification.vue?1e70a161